<p>
  text-item works!
</p>



// WEBPACK FOOTER //
// ./src/app/reports/text-item/text-item.component.html